import { Link } from 'react-router'
import { LuArrowRight, LuLeaf } from 'react-icons/lu'
import { ROUTES } from '@/constants/routes'
import { Reveal } from '@/components/ui/Reveal'
import { SectionHeader } from '@/components/ui/SectionHeader'
import { categories, products } from '@/data/products'

export const ProductsCatalog = () => (
  <section className="bg-base-50 py-16 sm:py-20 lg:py-24">
    <div className="mx-auto max-w-6xl px-6">
      <SectionHeader title="Clinical herbal" accent="formulations" className="mb-6" />

      <Reveal>
        <ul className="mb-8 flex flex-wrap gap-2">
          {categories.map((c) => (
            <li
              key={c.label}
              className="rounded-full border border-base-200 bg-white px-4 py-1.5 text-sm text-base-600"
            >
              {c.label}
              <span className="ml-2 text-base-500">{c.count}</span>
            </li>
          ))}
        </ul>
      </Reveal>

      <Reveal>
        <div className="mb-10 flex items-start gap-3 rounded-2xl border border-gold-200 bg-gold-50 p-5">
          <span aria-hidden="true" className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-gold-400" />
          <p className="text-sm leading-6 text-base-700">
            Our full product range will be available to purchase online shortly. To order now,
            please get in touch directly and Kandake will advise on the right formulation for you.
          </p>
        </div>
      </Reveal>

      <ul className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {products.map((p, index) => (
          <li key={p.n}>
            <Reveal delay={(index % 3) * 80} className="h-full">
              <div className="group flex h-full flex-col overflow-hidden rounded-3xl border border-base-200 bg-white transition-all duration-300 hover:border-green-300 hover:shadow-card-hover motion-safe:hover:-translate-y-1">
                {/* Product identity panel. Individual photography will replace this in Phase 2. */}
                <div className="relative flex aspect-[4/3] items-center justify-center overflow-hidden bg-gradient-to-br from-green-50 via-base-50 to-gold-50">
                  <div className="absolute -right-8 -top-8 h-32 w-32 rounded-full border border-green-200/60" />
                  <div className="absolute -bottom-12 -left-10 h-40 w-40 rounded-full border border-gold-200/70" />
                  <LuLeaf
                    aria-hidden="true"
                    className="h-14 w-14 text-green-700/35 transition-all duration-500 group-hover:scale-125 group-hover:rotate-6 group-hover:text-green-700/60"
                  />
                  <span className="absolute bottom-4 right-4 font-display text-3xl text-green-900/15">
                    {p.n}
                  </span>
                  <span className="absolute left-4 top-4 rounded-full border border-base-200 bg-white/90 px-3 py-1 text-xs font-medium text-base-600">
                    {p.category}
                  </span>
                </div>

                <div className="flex flex-1 flex-col p-6">
                  <h3 className="mb-1 font-display text-xl leading-tight text-base-900 transition-colors group-hover:text-green-800">
                    {p.name}
                  </h3>
                  <p className="mb-3 text-sm text-base-500">{p.format}</p>
                  <p className="flex-1 text-sm leading-6 text-base-600">{p.desc}</p>
                  <div className="mt-5 border-t border-base-200 pt-4">
                    <Link
                      to={`${ROUTES.CONTACT}?service=product`}
                      className="inline-flex min-h-11 items-center gap-2 rounded-sm text-sm font-medium text-green-700 transition-colors hover:text-green-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-green-700"
                    >
                      Enquire to Order
                      <LuArrowRight aria-hidden="true" className="h-4 w-4" />
                    </Link>
                  </div>
                </div>
              </div>
            </Reveal>
          </li>
        ))}
      </ul>
    </div>
  </section>
)
